import 'lazysizes';

lazySizes.cfg.lazyClass = 'js-lazy';
lazySizes.cfg.loadMode = 1;

document.addEventListener('LokiRequestEnd', function () {
    lazySizes.init()
})